var render, staticRenderFns
import script from "./FormLayout.vue?vue&type=script&lang=js"
export * from "./FormLayout.vue?vue&type=script&lang=js"
import style0 from "./FormLayout.vue?vue&type=style&index=0&id=af9427fe&prod&scoped=true&lang=scss"
import style1 from "./FormLayout.vue?vue&type=style&index=1&id=af9427fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9427fe",
  null
  
)

export default component.exports